<template>
    <div class="">
        <b-card v-if="campaign_description!=''" class="mb-5 py-3 f-95 px-3 ">
            <div class="line-height"
                 v-html="showTranslation(campaign_description, campaign_description_e, campaign_description_c)"
            />
        </b-card>
        <b-card v-if="campaign && campaign.required_info && campaign.required_info.length !== 0" header-tag="header"
                class="mb-5 ">
            <template v-slot:header>
                <h6 class="mb-0 fw-500 gray-550"> {{ $t('사전 정보 입력') }} </h6>
            </template>
            <b-table-simple class="mb-0">
                <b-tbody>
                    <b-tr v-for="(item, index) in required_info" :key="index" class="">
                        <b-td class="text-left border-0 p-1">
                            {{ index + 1 }}.
                        </b-td>
                        <b-td class="text-left border-0 p-1">
                            {{ item.title === '매출액' ? $t('매출액 정보를 선택하여 주십시오') : item.title }}
                            {{ item.title === '매출액' ? '' : $t('정보를 선택하여 주십시오') }}
                        </b-td>
                        <b-td class="text-left border-0 p-1">
                            <b-dropdown :text="required_info[index].result"
                                        variant="dark-border"
                                        :disabled="campaign.campaign_state === '완료'"
                                        block
                            >
                                <b-dropdown-item v-for="value in item.structure"
                                                 :key="value"
                                                 @click="handleSelect(index, value)"
                                >
                                    {{ $t(value) }}
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>

            <div v-if="validation_comment !== ''"
                 :class="validation_style"
                 class="mt-3"
            >
                <fa v-if="validation_icon !== ''" :icon="validation_icon"/>
                {{ validation_comment }}
            </div>
        </b-card>

        <div class="pt-2 mb-5 text-center">
            <b-button variant="blue" class="f-110" style="min-width: 30%;" @click.stop.prevent="startSurvey">
                {{ $t('시작하기') }}
            </b-button>
        </div>


        <b-modal id="information-policy-agree-modal"
                 :title="$t('정보 제공 동의')"
                 size="lg"
                 scrollable hide-footer hide-header-close no-close-on-backdrop no-close-on-esc
        >
            <div class="w-100 text-right mb-2">
                <dropdownLanguage class="ml-auto" size="sm"/>
            </div>
            <div class="overflow-auto"
                 style="max-height:400px;"
                 v-html="showTranslation(policy_content, policy_content_e, policy_content_c)"
            />
            <hr>
            <h6 class="mt-2 mb-3 text-center">
                {{ $t('정보 제공에 동의하십니까?') }}
            </h6>
            <b-form-radio-group v-model="selected" class="text-center" @change="handleAgree">
                <b-form-radio value="Y">{{ $t('예, 동의합니다.') }}</b-form-radio>
                <b-form-radio value="N">{{ $t('아니오, 동의하지 않습니다.') }}</b-form-radio>
            </b-form-radio-group>

            <div class="text-right">
                <span class="red">
                    <fa v-if="warning_msg !== ''" icon="exclamation-circle"></fa>
                    {{ $t(warning_msg) }}
                </span>
                <b-button
                    :variant="is_agree === false ? 'red' : 'blue'"
                    class="ml-3"
                    @click="handleOk"
                >
                    {{ $t('확인') }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import DropdownLanguage from '@shared_components/utils/dropdown-language';
import dayjs from 'dayjs';

export default {
    name: 'preface',
    components: {
        DropdownLanguage
    },
    data() {
        return {
            required_info: [
                {result: '', structure: [], title: ''}
            ],
            save_state: 'not_saved',
            validation_comment: '',
            validation_icon: '',
            validation_style: 'ih-validation-saved',
            selected: '',
            warning_msg: '',
            localePair: {
                ko: 'ENG',
                en: 'CHN',
                ca: 'KOR'
            }
        };
    },
    computed: {
        ...mapState('policies', {
            is_agree: state => state.is_agree,
            policy_content: state => state.policy_content,
            policy_content_e: state => state.policy_content_e,
            policy_content_c: state => state.policy_content_c,
            policy_id: state => state.policy_id
        }),
        ...mapState(['user_id', 'user_name', 'e_mail', 'company_name', 'company_id',
            'campaign_in_progress', 'question_in_progress', 'question_in_progress_loaded', 'template_in_progress'
        ]),
        campaign() {
            return this.$store.state.campaign_in_progress;
        },
        campaign_description() {
            return this.campaign.campaign_description;
        },
        campaign_description_e() {
            return this.campaign.campaign_description_e;
        },
        campaign_description_c() {
            return this.campaign.campaign_description_c;
        },
        project_code() {
            return this.campaign_in_progress.project_code;
        },
        number_of_questions() {
            return this.$store.getters.getNumberOfQuestions;
        },
        number_of_completed_questions() {
            return this.$store.getters.getNumberOfCompletedQuestions;
        },
        progress_rate() {
            return this.$store.getters.getProgressRate;
        },
        first_question() {
            const first_childer = this.$store.state.template_in_progress.template_contents[0].children[0];
            if (first_childer.children && first_childer.children.length) {
                return this.$store.state.template_in_progress.template_contents[0].children[0].children[0];
            } else {
                return this.$store.state.template_in_progress.template_contents[0].children[0];
            }
        }
    },
    watch: {
        save_state(_updated_save_state) {
            if (_updated_save_state === 'saving') {
                this.validation_comment = '저장 중 입니다.';
                this.validation_icon = 'hourglass';
                this.validation_style = 'ih-validation-saving';
            } else if (_updated_save_state === 'saved') {
                this.validation_comment = '저장 되어있습니다';
                this.validation_icon = 'check';
                this.validation_style = 'ih-validation-saved';
            } else if (_updated_save_state === 'resaved') {
                this.validation_comment = '변경 저장 되었습니다';
                this.validation_icon = 'check';
                this.validation_style = 'ih-validation-resaved';
            }
        }
    },
    async created() {
        await this.readRequiredInfo();
        this.clearPrevAttachments();
    },
    async mounted() {
        await this.showAgree();
    },
    methods: {
        ...mapMutations(['update_campaign_in_progress']),
        ...mapActions('policies', ['readAgree', 'saveAgree']),
        ...mapMutations('policies', ['set_is_agree']),
        ...mapActions('industry_campaigns', ['readNiceServiceStatus']),
        ...mapActions('attachments', ['clearPrevAttachments']),
        async readRequiredInfo() {
            try {
                if (this.campaign.required_info.length > 0) {
                    const response = await this.$axios.get('/read_required_info', {
                        params: {
                            campaign_id: this.campaign.campaign_id,
                            company_id: this.company_id
                        }
                    });

                    let temp_required_result = response.data;
                    if (temp_required_result.length > 0) {
                        for (let i = 0; i < this.campaign.required_info.length; i++) {
                            let new_info = {...this.campaign.required_info[i]};

                            if (typeof temp_required_result[i].result !== 'undefined' && temp_required_result[i].result !== '') {
                                new_info.result = temp_required_result[i].result;
                            } else {
                                if (this.$i18n.locale === 'ko') {
                                    new_info.result = `${this.campaign.required_info[i].title} 선택`;
                                } else {
                                    new_info.result = this.$t('선택') + this.campaign.required_info[i].title;
                                }

                            }

                            this.required_info.splice(i, 1, new_info);
                        }
                    } else {
                        this.required_info = [...this.campaign.required_info];
                        for (let i = 0; i < this.campaign.required_info.length; i++) {
                            if (this.$i18n.locale === 'ko') {
                                this.required_info[i].result = `${this.required_info[i].title} 선택`;
                            } else {
                                this.required_info[i].result = this.$t('선택') + this.required_info[i].title;
                            }
                        }
                    }
                }
            } catch (error) {
                await this.common_error_handling(error);
            }

        },
        async handleSelect(index, content) {
            try {
                let formData = new FormData();
                formData.append('campaign_id', this.campaign.campaign_id);
                formData.append('company_id', this.company_id);
                formData.append('title', this.campaign.required_info[index].title);
                formData.append('result', content);

                await this.$axios.post('/save_required_info', formData);
                this.required_info.splice(index, 1, {
                    title: this.required_info[index].title,
                    structure: this.required_info[index].structure,
                    result: content
                });
                this.$store.commit('update_temp_save_status', true);
                this.save_state = 'saved';
            } catch (error) {
                await this.common_error_handling(error);
            }
        },
        async showAgree() {
            // 접속한 캠페인의 campaign_id, 로그인한 기업의 company_id 보내서 동의 여부 상태 체크
            await this.readAgree({company_id: this.company_id, campaign_id: this.campaign.campaign_id});
            if (this.policy_id !== null && this.is_agree !== true) {
                this.$bvModal.show('information-policy-agree-modal');
            }
        },
        handleAgree() {
            this.$nextTick(() => {
                if (this.selected == 'Y') {
                    this.warning_msg = '';
                } else if (this.selected == 'N') {
                    // this.warning_msg = this.$t('동의하지 않으실 경우, 본 온라인 평가에 참여하실 수 없습니다.')
                    this.warning_msg = '동의하지 않으실 경우, 본 온라인 평가에 참여하실 수 없습니다.';
                }
            });
        },
        async handleOk() {
            if (this.selected === 'Y') {
                this.$bvModal.hide('information-policy-agree-modal');
                await this.saveAgree({
                    company_id: this.company_id,
                    campaign_id: this.campaign.campaign_id,
                    mode: true
                });

                // 상태 재조회가 실패해도 동의는 저장됐으므로 다음 단계로 진행한다
                try {
                    await this.readNiceServiceStatus({
                        campaign_id: this.campaign_in_progress.campaign_id,
                        company_id: this.company_id
                    });
                } catch (error) {
                    console.log(error);
                }

                const _updating_campaign_in_progress = {...this.campaign_in_progress};
                _updating_campaign_in_progress.status_code = 'in_progress';
                this.update_campaign_in_progress(_updating_campaign_in_progress);
            } else {
                alert('동의하지 않으실 경우, 본 온라인 평가에 참여하실 수 없습니다.');
                this.$router.push({name: 'Main'});
            }
        },
        async startSurvey() {
            await this.pageGo();
            this.$emit('move-next-question', this.first_question.question_code); //to ProviderAside
        },
        async pageGo() {
            let temp_question = {...this.first_question};
            if (typeof this.first_question.question_contents === 'string') {
                // string 형태로 가지고 있는 것 parsing 해야함
                temp_question.question_contents = JSON.parse(this.first_question.question_contents);
            }
            this.$store.commit('update_question_in_progress', temp_question);
            try {
                await this.$store.dispatch('questions/readSubs', {
                    company_id: this.$route.query.cpn,
                    campaign_id: this.$route.query.cmp,
                    code: temp_question.question_code,
                    contents: temp_question.question_contents,
                    path: 'preface'
                });
            } catch (error) {
                this.$EventBus.$emit('toast-failure', this.$t('알림'), this.$t('문항을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.'));
            }
            this.$nextTick(() => {
                // console.log('퀘스천 코드' + temp_question.question_code)
                this.$router.push({
                    name: 'Questions',
                    params: {question_code: temp_question.question_code},
                    query: {...this.$route.query}
                });
            });
        }
    }
};
</script>

<style scoped>
.preface-required > header.card-header {
    background-color: var(--gray-600);
    padding: 0.5rem 1rem;
}

.preface-required > div.card-body {
    padding: 0.75rem 1rem;
}

</style>
